var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 10.5,
    fill: "#071E0D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 6.5,
    fill: "#F7FFF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectorIcon);
export default __webpack_public_path__ + "static/media/selectorIcon.6438cc4e5da8c8f230910697b855ce9a.svg";
export { ForwardRef as ReactComponent };